import memoize from "memoize-one"

export const translationRegex = /^main:/

export const checkIfTranslation = memoize(
    string => !!translationRegex.test(string),
)
